import Index, {getServerSideProps} from "@page-containers/get-care/index";

export {getServerSideProps};
export default Index;
